import { CurrentLocation } from 'interfaces/components';
import { ENV } from 'evcharging/app';

export const CONTACT_ADDRESSES: CurrentLocation[] = [
  {
    address: '1080 N Delaware Ave, Suite 511, Philadelphia PA 19125.',
    lat: 39.9656693,
    lng: -75.1327129,
    city: 'Philadelphia',
  },
  {
    address: '1051 Perimeter Dr, Suite 510, Schaumburg IL 60173',
    lat: 42.0489163,
    lng: -88.033518,
    city: 'Chicago',
  },
  {
    address: '13 Branch St, Suite 207, Methuen MA 01844',
    lat: 42.7064758,
    lng: -71.2124645,
    city: 'Boston',
  },
  {
    address: '965 Greentree Rd, Suite 400, Pittsburgh PA 15220',
    lat: 40.4347039,
    lng: -80.0351135,
    city: 'Pittsburgh',
  },
];

export const DelawareMapLink = 'https://goo.gl/maps/i7JVtY3oCpYiZep57';

export const getGoogleMapKey = () => ENV.GOOGLE_MAP_KEY;
